import { Component, Input } from "@angular/core";

import { SkeletonModule } from "primeng/skeleton";

import { AccordionComponent } from "@shared/components";
import { DaysData } from "@shared/models";
import { CommonModule } from "@angular/common";
import { fadeInOutAnimation } from "@shared/animations";

@Component({
  selector: "app-days",
  standalone: true,
  imports: [AccordionComponent, SkeletonModule, CommonModule],
  templateUrl: "./days.component.html",
  styleUrl: "./days.component.scss",
  animations: [fadeInOutAnimation],
})
export class DaysComponent {
  @Input() daysData: DaysData = {} as DaysData;

  visible: boolean = false;

  handleVisible(event: any) {
    this.visible = event;
  }
}
